<div class="appContainer">
  <!-- side bar -->
  <app-sidenav></app-sidenav>

  <div class="pageContent" role="main">

    <!-- header -->
    <app-header></app-header>

    <div class="user-table">

      <div class="searchFilter">

        <div class="date-range-container">
          <mat-menu #menuDatesPageFilter="matMenu" xPosition="before" [overlapTrigger]="false"
            class="menu-dates-page-filter-drop">
            <div class="date-range-picker-container" style="padding: 20px 40px 10px 40px;width: 530px"
              (click)="$event.stopPropagation();">
              <style>

              </style>
              <div style="display: flex;flex-wrap: wrap; justify-content: flex-start;">
                <!-- <div><a (click)="onDateRangeFilterTimeSet(60)">Last Hour</a></div> -->
                <div><a (click)="_setDateFilterToToday()"
                    [ngClass]="{ 'disabled': this.timeRange.displayNameOfSelected == 'Today' }">Today</a></div>
                <div><a (click)="_setDateFilterToYesterday()"
                    [ngClass]="{ 'disabled': this.timeRange.displayNameOfSelected == 'Yesterday' }">Yesterday</a>
                </div>
                <div><a (click)="_setDateFilterToLastNDays(7)"
                    [ngClass]="{ 'disabled': this.timeRange.displayNameOfSelected == 'Last 7 Days' }">Last 7
                    Days</a></div>
                <div><a (click)="_setDateFilterToLastNDays(14)"
                    [ngClass]="{ 'disabled': this.timeRange.displayNameOfSelected == 'Last 14 Days' }">Last 14
                    Days</a></div>
              </div>
              <div style="display: flex; ">
                <div style="width: calc(50% - 20px); padding-right: 20px; margin-top: 20px; font-size: 12px">
                  <div class="mat-calander-header">From</div>

                  <mat-calendar [selected]="timeRange.selectedDates.from" [maxDate]="timeRange.maxDate"
                    (selectedChange)="onPageFilterDateFromSelect($event)"></mat-calendar>
                </div>
                <div
                  style="width: calc(50% - 20px); flex-grow: 1 50%; padding-left: 20px; margin-top: 20px;font-size: 12px">
                  <div class="mat-calander-header">To</div>

                  <mat-calendar [selected]="timeRange.selectedDates.to" [maxDate]="maxEndDateRange" [minDate]="timeRange.selectedDates.from"
                    (selectedChange)="onPageFilterDateToSelect($event)"></mat-calendar>
                </div>
              </div>
              <div style="position: relative; height: 50px;">
                <button style="position: absolute; right: 10px; top: 6px;" mat-raised-button color="primary"
                  (click)="onDateFilterSubmit()">Apply</button>
              </div>
            </div>
          </mat-menu>
          <!-- <div class="content-header-right-button-label">Dates</div> -->
          <button mat-raised-button class="last" [matMenuTriggerFor]="menuDatesPageFilter"
            #menuDatesFilterTrigger="matMenuTrigger" (menuClosed)="onDatesFilterClosed()">
            {{ timeRange.displayNameOfSelected }}
            <mat-icon>expand_more</mat-icon></button>
        </div>

        <!-- <div class="dropDown">
          <select (change)="onChangeSearchOption($event.target.value)">
            <option value="all"> All </option>
            <option value="Text"> Expression </option>
            <option value="SkillLabel"> Skill </option>
            <option value="Timestamp"> Date </option>
          </select>
        </div>
        <div class="searchInput">
          <div class="searchImg">
            <img src={{searchImagePath}} alt="" />
          </div>
          <input type="text" [(ngModel)]="UnknownRequestTable.searchText" (keydown)="changeSearchText($event)"
            (keyup)="changeSearchText($event)" placeholder="Search ..." />
          <div class="clearImg" *ngIf="UnknownRequestTable.searchText != ''">
            <img src={{clearImagePath}} alt="" (click)="ClearSearchText()" />
          </div>
        </div> -->
        <!-- <div class="topActions syncDiv">
          <span class="syncText"> Last synced at: <b> {{ lastSyncedTime.substring(0, 19) }} </b> </span>
        </div>
        <div class="topActions">
          <button (click)="syncCosmosData()"> Sync </button>
        </div> -->
        <div class="topActions pull-button-right">
          <button (click)="showHideExport()"> Export </button>
          <div class="topActions accord" *ngIf="showHideExportDiv == true">
            <p class="exportHeader"> Export CSV </p>
            <mat-label> Start date</mat-label>
            <mat-form-field class="example-full-width">
              <mat-label>Choose a date</mat-label>
              <input matInput [max]="maxDate" [matDatepicker]="picker" (dateChange)="onStartDateChanged($event)" [(ngModel)]="startDate" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <mat-label> End date</mat-label>

            <mat-form-field class="example-full-width">
              <mat-label>Choose a date</mat-label>
              <input matInput [matDatepicker]="picker2" [min]="startDate" [max]="maxEndDate" [(ngModel)]="endDate" readonly>
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            <button (click)="downloadReport()"> Submit </button>
            <button class="clearButton" (click)="showHideExport()"> Exit </button>
          </div>
        </div>
      </div>

      <div class="table-scroll">
        <table mat-table [dataSource]="UnknownRequestTable.dataSource" multiTemplateDataRows class="mat-elevation-z8">

          <!-- <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
        <th mat-header-cell *matHeaderCellDef> {{column}} </th>
        <td mat-cell *matCellDef="let element"> {{element[column]}}</td>
      </ng-container> -->

          <!-- Index No Column -->
          <ng-container matColumnDef="Sno">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td mat-cell *matCellDef="let element">
              <mat-icon class="show-conversaions" 
              (click)="onClickConverstations(element.conversation_id)"
              (click)="expandedElement = expandedElement === element ? null : element">{{ expandedElement === element ? 'expand_less' : 'expand_more'}}</mat-icon>
            </td>
          </ng-container>

          <!-- Timestamp Column -->
          <ng-container matColumnDef="Timestamp">
            <th mat-header-cell *matHeaderCellDef (click)="sortData('Timestamp')"> Date
              <!-- <i class="material-icons touchIcons" *ngIf="UnknownRequestTable.sortByCol=='Timestamp'">
                {{ UnknownRequestTable.sortByType =="DESC" ?"arrow_drop_up":"arrow_drop_up"}} </i>
              <span>
                <div class="sortIcons"> <i class="material-icons touchIcons upIcon"
                    *ngIf="UnknownRequestTable.sortByCol !='Timestamp'"> {{ "arrow_drop_up" }} </i> </div>
                <div class="sortIcons"> <i class="material-icons touchIcons downIcon"
                    *ngIf="UnknownRequestTable.sortByCol !='Timestamp'"> {{ "arrow_drop_down" }} </i> </div>
              </span> -->
            </th>
            <td mat-cell *matCellDef="let element"> {{element.Timestamp | date:'medium'}} </td>
          </ng-container>

          <!-- Text Column -->
          <ng-container matColumnDef="Text">
            <th mat-header-cell *matHeaderCellDef (click)="sortData('Text')" style="width: 20%;"> Expression
              <!-- <i class="material-icons touchIcons" *ngIf="UnknownRequestTable.sortByCol=='Text'">
                {{ UnknownRequestTable.sortByType =="DESC" ?"arrow_drop_down":"arrow_drop_up"}} </i>
              <span>
                <div class="sortIcons"> <i class="material-icons touchIcons upIcon"
                    *ngIf="UnknownRequestTable.sortByCol !='Text'"> {{ "arrow_drop_up" }} </i> </div>
                <div class="sortIcons"> <i class="material-icons touchIcons downIcon"
                    *ngIf="UnknownRequestTable.sortByCol !='Text'"> {{ "arrow_drop_down" }} </i> </div>
              </span> -->
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.Text}}
            </td>
          </ng-container>

          <!-- Skill assignment Column -->
          <ng-container matColumnDef="Skill assignment">
            <th mat-header-cell *matHeaderCellDef> Skill Assignment </th>
            <td (click)="$event.stopPropagation();" mat-cell *matCellDef="let element">
              <mat-form-field>
                <mat-select placeholder="Choose skills" (selectionChange)="onSelectionChange(element)" [(value)]="element.SkillLabel"
                >
                  <mat-select-filter [placeholder]="'Search Skills'" [displayMember]="'intent'" [array]="intentSkills"
                    (filteredReturn)="getFilteredValues($event)"></mat-select-filter>
                  <mat-option *ngIf="element.SkillLabel">Clear Selection</mat-option>
                  <mat-option *ngFor="let item of intentSkills" [value]="item.intent">
                    {{item.intent}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Skill response Column -->
          <!-- <ng-container matColumnDef="SkillLabel">
          <th mat-header-cell *matHeaderCellDef (click)="sortData('SkillLabel')" style="width: 20%;"> Skill Response  </th>
          <td mat-cell *matCellDef="let element"> <span *ngFor="let item of intentSkills"> <span *ngIf="(item.intent == element.SkillLabel)"> 
            <nga-read-more [text]="item.Response" [textLength]="25"></nga-read-more>
          </span>  </span> </td>
        </ng-container> -->

          <!-- Skill assignment Column -->
          <ng-container matColumnDef="Comments">
            <th mat-header-cell *matHeaderCellDef> Comments </th>
            <td (click)="$event.stopPropagation();" mat-cell *matCellDef="let element">
              <mat-form-field class="example-full-width">
                <mat-label>Comments</mat-label>
                <input matInput placeholder="Comments " (ngModelChange)="onCommentChange(element)" [(ngModel)]="element.comment">
              </mat-form-field>
            </td>
          </ng-container>

          <!-- Operation Column -->
          <ng-container matColumnDef="Operations">
            <th mat-header-cell *matHeaderCellDef style="width: 85px"> Review Status
            </th>
            <td mat-cell *matCellDef="let element">
              <i *ngIf="(element.saved && !element.updated)" class="material-icons opIcons" [class]="(element.saved && !element.updated) ?' selected_operation':''"
               > check_circle_outline </i>
              <!-- <i class="material-icons opIcons" (click)="DeleteUnknownRequestItem(element.id)"> delete_outline </i> -->
              <div class="save-button" *ngIf="isEdited(element)"  (click)="UpdateUnknownRequestItem(element)">Save</div>
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="UnknownRequestTable.columnsToDisplay.length">
              <div class="example-element-detail"
                [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                <div class="example-element-description">
                  <!-- <app-conversation-log-simple [ConversationId]="element.conversation_id" [Converstation]="converstation" [isLoading]="isLoading" 
                    [IntentSkills]="intentSkills"></app-conversation-log-simple> -->
                    <app-conversation-log [ConversationId]="element.conversation_id" [Converstation]="converstation" [isLoading]="isLoading" 
                    [IntentSkills]="intentSkills" (getConversationList)="GetConversationListForce()"></app-conversation-log>
                </div>
              </div>
            </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="UnknownRequestTable.columnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let element; columns: UnknownRequestTable.columnsToDisplay;"
            class="example-element-row" [class.example-expanded-row]="expandedElement === element">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          <!-- <tr mat-row *matRowDef="let row; columns: []" class="example-detail-row"></tr> -->
        </table>
        <mat-paginator [length]="UnknownRequestTable.lenght" [pageSize]="UnknownRequestTable.pagination.limit"
          [pageSizeOptions]="UnknownRequestTable.pagination.pageSizeOptions" (page)="getPaginatorData($event)">
        </mat-paginator>
      </div>

      <!-- <mat-paginator
    #paginator
    [length]="UnknownRequestTable.pagination.totalCount" 
    [pageIndex]="UnknownRequestTable.pagination.pageNo" 
    [pageSize]="UnknownRequestTable.pagination.limit"
    [pageSizeOptions]="[10, 15, 20]" 
    (page)="getPaginatorData($event)"
    showFirstLastButtons>
    </mat-paginator> -->

    </div>
  </div>